import { Component, OnInit, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormioFunctions } from '@app/model/formio-functions.model';
import { FormioComponent } from 'angular-formio';
import { Portuguese } from 'node_modules/flatpickr/dist/l10n/pt';

@Component({
  selector: 'app-edit-form-viewer',
  styleUrls: ['./edit-form-viewer.scss'],
  template: '<formio #formViewer [renderOptions]="renderOptions" [form]="form" [options]="options"></formio>',
  // encapsulation: ViewEncapsulation.ShadowDom
})


export class EditFormViewerComponent implements OnInit {

    constructor(public formioFunctions: FormioFunctions) {}

    @Input() fieldJson;
    @Input() defaultColor? = false;
    public alternateFieldJson;
    public form;
    public renderOptions = {
      executeScripts: false,
      sanitizeConfig: {
        addTags: ['iframe', 'script'],
        addAttr: ['srcdoc']
      }
    };
    public options = {
      alerts: {
        submitMessage: 'Submissão concluída.'
      },
      errors: {
        message: 'Falha no envio.'
      },
      i18n: {
        en: {
            error : '',
            invalid_date : '{{field}}  precisa ser uma data valida.',
            invalid_email : '{{field}} precisa ser um E-mail valido.',
            invalid_regex : '{{field}} não combina com o padrão regex',
            mask : '{{field}} não combina com a máscara.',
            max : '{{field}} não pode ser maior que {{max}}.',
            maxLength : '{{field}} precisa ser mais curto que {{length}} caracteres.',
            min : '{{field}} não pode ser menor que {{min}}.',
            minLength : '{{field}} precisa ser mais longo que {{length}} caracteres.',
            next : 'Próximo',
            pattern : '{{field}} does not match the pattern {{pattern}}',
            previous : 'Anterior',
            required : '{{field}} é obrigatório'
        },
      },
    };
    @ViewChild('formViewer', {static: false}) formViewer: FormioComponent;

    ngOnInit() {
      this.alternateFieldJson = JSON.parse(JSON.stringify(this.fieldJson));
      this.alternateFieldJson.components[0].hidden = false; 
      this.alternateFieldJson.components[0].conditional = {};
      if (this.alternateFieldJson.components[0].type === 'content') {
        this.alternateFieldJson.components[0].customClass += ' ps-form-builder-content-link-preview-noClick';
      }
      if (this.alternateFieldJson.components[0].type === 'button') {
        if(this.alternateFieldJson.components[0].externalColor === 'default' && this.defaultColor) {
          this.alternateFieldJson.components[0].externalColor = this.defaultColor;
        }
        if(this.alternateFieldJson.components[0].internalColor === 'default' && this.defaultColor) {
          this.alternateFieldJson.components[0].internalColor = this.defaultColor;
        }
      }

      if(this.alternateFieldJson.components[0].copy) {
        const suffix = this.alternateFieldJson.components[0].suffix ?? '';
        this.alternateFieldJson.components[0].suffix = suffix + '<span style="margin-left:3px" class="material-icons">content_copy</span>';
      }

      this.form = this.alternateFieldJson;
      if ((window as any).flatpickr) {
        (window as any).flatpickr.localize(Portuguese);
      }
    }

}
